import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Stack,
  Breadcrumb,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

// Added by Jaseem 11-2-2026
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
//=====================================================

import solisPowerApi from "../../api/solisPowerApi";
import ".././../assets/css/ListComponentsTable.css";
import { ROUTES } from "../../constants/webRouting";
import InfoPill from "../InfoPill";
import { getUserDetails } from "../../utils/helper";
import PERMISSIONS from "../../constants/permissions";

const ContactList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();
  const [body, setBody] = useState();

  //Added By Jaseem 11-02-2026
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchText, setSearchText] = useState("");

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredRows(filtered);
  };

  useEffect(() => {
    async function init() {
      const result = await solisPowerApi.fetchContacts();

      if (result) {
        setBody(result);

        const mappedRows = result.map((item, index) => ({
          id: item.id || index, // DataGrid ke liye mandatory
          firstname: item.firstname || "-",
          createddate: item.createddate || "-",
          street: item.street || "-",
          city: item.city || "-",
          email: item.email || "-",
          phone: item.phone || "-",
          title: item.title || "-",
        }));

        setRows(mappedRows);
        setFilteredRows(mappedRows);
      } else {
        setBody([]);
      }
    }
    init();
  }, []);

  const columns = [
    {
      field: "firstname",
      headerName: "Name",
      flex: 1,
      // renderCell: (params) => params.row.contact_name || "-",
      renderCell: (params) => {
        const row = params.row;

        return (
          <Link
            to={`${ROUTES.CONTACT.LIST}/${row.id}`}
            state={row}
            style={{
              color: "#1a73e8",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            {row.firstname}
          </Link>
        );
      },
    },

    { field: "street", headerName: "Complete Address", flex: 1 },
    { field: "city", headerName: "City", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "phone", headerName: "Mobile Number", flex: 1 },
    { field: "title", headerName: "Contact Type", flex: 1 },
  ];

  // ========================================= 11-02-2026 ==========================================

  const createContact = () => {
    navigate(ROUTES.CONTACT.CREATE);
  };

  const customFilter = (rows, filters) => {
    return rows.filter((row) => {
      return Object.keys(filters).every((column) => {
        const filterValue = filters[column]?.toLowerCase() || "";
        if (!filterValue) return true; // filter empty hai to row include karo

        const rowValue = row[column]?.toString().toLowerCase() || "";
        return rowValue.includes(filterValue); // substring + case-insensitive
      });
    });
  };

  return (
    <Container fluid>
      <Row className="align-items-end ">
        <Breadcrumb>
          <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item onClick={() => navigate(ROUTES.CONTACT.LIST)}>
            Contacts
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* Added By Jaseem 11-02-2026 */}
        <Col lg={2} md={4} xl={2} sm={12} className="">
          <div className="leads-header">
            <div className="leads-actions">
              <TextField
                size="small"
                placeholder="Search Contacts..."
                className="custom-search-field"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>
        </Col>
        {/* =================================================== */}
        <Col className="py-1">
          {/* <BrowserView> */}
          <div className="d-flex py-1 px-2 ">
            <InfoPill
              left="Total"
              right={body?.length}
              rightClasses="bg-custom text-white border-white fw-bold"
              leftClasses="bg-white  fw-bold "
            />
          </div>
          {/* </BrowserView> */}
        </Col>
        <Col
          xs={12}
          sm={6}
          lg={4}
          className="d-flex flex-col justify-content-end align-items-end"
        >
          <Stack direction="horizontal" gap={2}>
            {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_CONTACT].some(
              (permission) => {
                return userInfo?.permissions
                  .map((p) => p.name)
                  .includes(permission);
              },
            ) && (
                <Button
                  size="sm"
                  className="btn-create"
                  onClick={() => createContact(true)}
                >
                  New Contact
                </Button>
              )}
          </Stack>
        </Col>
      </Row>
      {/* Added By Jaseem 11-02-2026 */}
      <Row>
        <div className="leads-page">
          {/* Header */}

          {/* DataGrid */}
          <div
            style={{
              height: 400,
              width: "100%",
              marginTop: "20px",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            }}
          >
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={25}
              rowsPerPageOptions={[25]}
              getRowHeight={() => "auto"}
              disableRowSelectionOnClick
              className="custom-datagrid"
            />
          </div>
        </div>
      </Row>
      {/* ==========================End By Jaseem ============================================= */}
    </Container>
  );
};

export default ContactList;
